import { useMemo } from 'react'

import { ChildcareRequest } from 'modules/benefits/components/benefitModals/ChildcareRequest'
import HealthcareEnrollmentWizardContainer from 'modules/benefits/components/benefitModals/HealthcareEnrollmentWizard/HealthcareEnrollmentWizardContainer'
import HealthcarePlanWizardContainer from 'modules/benefits/components/benefitModals/HealthcarePlanWizard/HealthcarePlanWizardContainer'
import { TrainingRequestWizard } from 'modules/benefits/components/benefitModals/TrainingRequestWizard'
import { WellnessSidepanel } from 'modules/benefits/components/benefitModals/WellnessSidepanel'

import { useBenefitModals } from '../useBenefitModals'

export const BenefitModals = () => {
  const {
    state: { openModal },
  } = useBenefitModals()

  const wizard = useMemo(() => {
    switch (openModal) {
      case 'childcare_request':
        return <ChildcareRequest />
      case 'training_request':
        return <TrainingRequestWizard />
      case 'wellness_information':
        return <WellnessSidepanel />
      case 'healthcare_plan_create':
        return <HealthcarePlanWizardContainer />
      case 'healthcare_plan_enrollment':
        return <HealthcareEnrollmentWizardContainer />
      default:
        return null
    }
  }, [openModal])

  return wizard
}
